import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "14",
  height: "14",
  fill: "currentColor",
  class: "ai-sidebar-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" })
], -1 /* HOISTED */)
const _hoisted_3 = { class: "sidebar-item-label ai-sidebar-label" }
const _hoisted_4 = { class: "ai-status-indicator" }
const _hoisted_5 = {
  class: "spinner-border spinner-border-sm ai-header-spinner",
  role: "status",
  style: {"width":"14px","height":"14px","border-width":"0.15em","color":"white"}
}
const _hoisted_6 = {
  key: 0,
  class: "ai-unread-badge"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["collapse-sidebar-link ai-sidebar-item ai-header-button-root", { 'active-sidebar': $setup.hasActiveThread }]),
    onClick: $setup.openBrowser,
    title: $setup.activeTitle,
    style: {"position":"relative"}
  }, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString($setup.activeTitle), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */), [
        [_vShow, $setup.isThinking]
      ]),
      ($setup.unreadCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.unreadCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}